module.exports = __webpack_public_path__ + "static/media/binaries.95e7ad67.svg";